import { SVG } from '../SVG'

export const LinkedinIcon = ({ style = {}, ...props }) => (
  <SVG
    width='35'
    height='35'
    viewBox='0 0 35 35'
    fill='none'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...style }}
    {...props}
  >
    <path
      d='M17.5 34.375C26.8198 34.375 34.375 26.8198 34.375 17.5C34.375 8.18019 26.8198 0.625 17.5 0.625C8.18019 0.625 0.625 8.18019 0.625 17.5C0.625 26.8198 8.18019 34.375 17.5 34.375Z'
      fill='#0073B1'
    />
    <path
      d='M13.0988 26.2894H9.52691V13.1691H13.0988V26.2894ZM11.3128 11.6503C10.8945 11.6531 10.4847 11.5314 10.1357 11.3007C9.78665 11.07 9.51411 10.7407 9.35271 10.3547C9.19132 9.9687 9.14836 9.54342 9.2293 9.13294C9.31025 8.72245 9.51143 8.34531 9.80728 8.04946C10.1031 7.75362 10.4803 7.55243 10.8907 7.47149C11.3012 7.39055 11.7265 7.43351 12.1125 7.5949C12.4985 7.75629 12.8278 8.02883 13.0585 8.37787C13.2892 8.7269 13.4109 9.13665 13.4082 9.55503C13.4082 10.1107 13.1874 10.6437 12.7945 11.0366C12.4015 11.4296 11.8686 11.6503 11.3128 11.6503V11.6503ZM27.4285 26.2894H23.8425V19.6097C23.8425 15.5878 19.0753 15.8972 19.0753 19.6097V26.2894H15.4894V13.1691H19.0753V15.2785C20.7347 12.1847 27.4285 11.9597 27.4285 18.2316V26.2894Z'
      fill='white'
    />
  </SVG>
)

export default LinkedinIcon
